import { createReducer } from '@reduxjs/toolkit'

import * as actions from '../actions'
import { IPWAState } from '../types'

const initialState: IPWAState = {
  isNotificationShown: false,
}

export default createReducer(initialState, builder => {
  builder.addCase(actions.hideNotification, state => {
    state.isNotificationShown = true
  })
})
